export default function OtherResourcesController(
  $q,
  $rootScope,
  $scope,
  alerts,
  bcpSharedModelService,
  confirmDialog,
  editOtherResourcesDialog,
  loaderService,
  ssDialogService,
  userService
) {
  const vm = this;

  vm.canExpand = true;
  vm.hasData = false;
  vm.handleExpand = _handleExpand;
  vm.handleAdd = _handleAdd;
  vm.handleEdit = _handleEdit;
  vm.handleDelete = _handleDelete;
  vm.loadOtherResources = _loadOtherResources; // for import

  _activate();

  /** **************************************************
   * Event Handlers
   */

  function _handleExpand() {
    if (!vm.hasData) {
      return _loadOtherResources();
    }
    return Promise.resolve();
  }

  function _handleAdd($event) {
    return _showDialog($event, {
      otherResource: { // New record
        assessmentId: vm.assessmentId,
        assessmentOtherResourceId: -1,
        website: '',
        supportPhone: '',
        supportEmail: '',
      },
    });
  }

  function _handleEdit($event, otherResource) {
    return _showDialog($event, { otherResource });
  }

  function _handleDelete($event, otherResource) {
    ssDialogService.dialogs.bcp.confirmDeleteOtherResourceDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Other External Resource?',
        message: `Are you sure you want to delete the Other External Resource "${otherResource.name}"?`,
        handleYesClick() {
          _deleteResource(otherResource.assessmentOtherResourceId);
        },
        handleNoClick: _closeConfirmDeleteDialog,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.confirmDeleteOtherResourceDialog);
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
    $scope.$on('refreshOtherResources', _loadOtherResources);
    loaderService.showViewLoader = true;
    $q.all([
      userService.getUserPermissionSet('bcp'),
      userService.getUser()
    ]).then((results) => {
      loaderService.showViewLoader = false;
      vm.permissions = results[0];
      vm.customerId = results[1].customerId;
    });
  }

  function _loadOtherResources() {
    loaderService.showViewLoader = true;
    return bcpSharedModelService.getOtherResources(vm.assessmentId, true)
      .then((otherResources) => {
        loaderService.showViewLoader = false;
        vm.otherResources = otherResources;
        if (otherResources && otherResources.length > 0) {
          vm.status = `${otherResources.length} Other Resources`;
        } else {
          vm.status = 'No Other Resources Added';
        }
        $rootScope.$broadcast('refreshOtherResourcesStatus', { status: vm.status });
        vm.hasData = true;
      });
  }

  function _deleteResource(assessmentOtherResourceId) {
    loaderService.showViewLoader = true;
    return bcpSharedModelService.deleteOtherResource(assessmentOtherResourceId)
      .then(() => {
        _loadOtherResources();
        alerts.success('The Other External Resource has been deleted successfully.');
        _closeDialog();
      }).catch(() => {
        alerts.error('Error occurred while deleting the Other External Resource.');
      }).finally(() => {
        loaderService.showViewLoader = false;

        // Old way of refreshing the entire BCP Plan
        // $rootScope.$broadcast('refreshBCPAssessments');
        $rootScope.$broadcast('refreshNotifications');
        return _closeConfirmDeleteDialog();
      });
  }

  function _showDialog($event, locals) {
    ssDialogService.dialogs.bcp.editOtherResourcesDialog = ssDialogService.alert(
      editOtherResourcesDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.editOtherResourcesDialog);
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.editOtherResourcesDialog);
  }

  function _closeConfirmDeleteDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.confirmDeleteOtherResourceDialog);
  }
}

OtherResourcesController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'bcpSharedModelService',
  'confirmDialog',
  'editOtherResourcesDialog',
  'loaderService',
  'ssDialogService',
  'userService'
];
